import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StorageConstants } from '@picard/shared-lib';

@Component({
  selector: 'app-voucher-landing',
  templateUrl: './voucher-landing.component.html',
  styleUrls: ['./voucher-landing.component.css']
})
export class VoucherLandingComponent implements OnInit {

  pointBalance: any;
  
  constructor(private _router: Router) { }

  ngOnInit() {
    this.pointBalance = sessionStorage.getItem("LoyaltyRewardBalance");
  }

  openConvertModal() {
    this._router.navigateByUrl(`/dashboard/1`);
  }
  toVouchers(){
    this._router.navigateByUrl(`/vouchers`);
  }

}
